export const UNKNOWN = 'UNKNOWN';
export const PREAPPROVAL = 'PREAPPROVAL';
export const FINAL = 'FINAL';
export const DECLINE = 'DECLINE';
export const REVIEW = 'REVIEW';
export const SELECT = 'SELECT';
